/*=========================================================================================
  File Name: moduleAuthentication.js
  Description: Authentication Module
  ----------------------------------------------------------------------------------------
==========================================================================================*/


import state from './moduleAuthenticationState.js'
import mutations from './moduleAuthenticationMutations.js'
import actions from './moduleAuthenticationActions.js'
import getters from './moduleAuthenticationGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
